import type { ReactNode } from 'react';

type LabelProps = {
  label: string;
};

/**
 * The betslip label component wrapper.
 *
 * @param root0 input object
 * @param root0.label the label to display inside.
 * @returns div with label inside.
 */
export default function BetslipLabel({ label }: LabelProps): ReactNode {
  return <div className="mr-[6px] grid w-fit items-center text-nowrap [grid-area:label] lg:mr-[12px]">{label}</div>;
}
